import { TAuditTrailResponse } from "../../apis/auditTrail/auditTrail.interfaces";

export const auditTrailResponseMock: TAuditTrailResponse = {
  entries: [],
  totalCount: 0,
  page: 1,
  pageSize: 10,
  totalPages: 0,
};
